// extracted by mini-css-extract-plugin
export default {"root":"QOX0dS","bg":"MAs5Tr"};